module.exports = __webpack_public_path__ + "img/project1_4.png.d575cc63.webp";